import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import TermsDocument from '../components/TermsDocument';
import { PARTNERS_SITE_URL } from '../lib/links';

// Public, unauthenticated. Linked from the registration checkbox, the re-acceptance modal and
// the profile page — a partner must be able to read what they agreed to without signing in.
const TermsPage = () => (
  <div className="min-h-screen bg-[#FAFAF8] py-8 px-4">
    <div className="max-w-3xl mx-auto">
      <a
        href={PARTNERS_SITE_URL}
        className="inline-flex items-center gap-2 text-[#64748B] hover:text-[#1A1A1A] mb-8 transition-colors"
      >
        <ArrowLeft className="w-4 h-4" />
        <span className="text-sm">Back to Expedify Partners</span>
      </a>

      <div className="bg-white rounded-2xl border border-[#E2E2DF] p-8 shadow-sm">
        <TermsDocument />
      </div>

      <p className="mt-6 text-center text-sm text-[#64748B]">
        <Link to="/login" className="text-[#ee785b] font-semibold hover:underline">
          Sign in
        </Link>
        {' · '}
        <Link to="/register" className="text-[#ee785b] font-semibold hover:underline">
          Apply as a partner
        </Link>
      </p>
    </div>
  </div>
);

export default TermsPage;
